import { sanitizeDecimalTyping, type DecimalTypingOptions } from '@record-fill';

export function sanitizeNumberInputValue(value: unknown, options: DecimalTypingOptions = {}): string {
  return sanitizeDecimalTyping(String(value ?? ''), options);
}
